import _slicedToArray from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/**
 * Datepicker.js
 *
 * Copyright (c) apploft. GmbH
 */
import DatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';
import React, { useState } from 'react';
import { stringMatching } from '../../Theme';
import './react-datepicker.css';

function ReactDatePicker() {
  return React.createElement(DatePicker);
}
/**
 * Returns Date from `defaultValue` or value (which can `null`).
 *
 * @param {{value?: Date, defaultValue?: string}} param0
 */


function createDefaultDate(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value,
      defaultValue = _ref.defaultValue;

  if (typeof defaultValue !== 'string') {
    return value;
  }

  return new Date(defaultValue);
}

function createMinDate() {
  var now = new Date();
  now.setHours(now.getHours() + 1);
  return now;
}

function ControlledDatePicker(_ref2) {
  var name = _ref2.name,
      control = _ref2.control,
      defaultValue = _ref2.defaultValue;
  var minDate = createMinDate();
  var defaultDate = createDefaultDate({
    value: minDate,
    defaultValue: defaultValue
  });

  var _useState = useState(defaultDate),
      _useState2 = _slicedToArray(_useState, 2),
      startDate = _useState2[0],
      setStartDate = _useState2[1];

  return React.createElement(Controller, {
    name: name,
    timeFormat: 'HH:mm',
    timeIntervals: 15,
    timeCaption: 'time',
    dateFormat: 'MMMM d, yyyy h:mm aa',
    as: ReactDatePicker(),
    control: control,
    showTimeSelect: true,
    selected: startDate,
    defaultValue: defaultDate,
    minDate: minDate,
    onChange: function onChange(_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
          date = _ref4[0];

      setStartDate(date);
      return date;
    }
  });
}

function Main(_ref5) {
  var name = _ref5.name,
      control = _ref5.control,
      defaultValue = _ref5.defaultValue,
      strings = _ref5.strings;
  var label = stringMatching(strings, name);
  return React.createElement(React.Fragment, null, React.createElement('label', null, label), React.createElement(ControlledDatePicker, {
    name: name,
    control: control,
    defaultValue: defaultValue
  }));
}

export default Main;